<template>
  <div class="">
    <div class="flex md:hidden items-center justify-between mt-6 mx-8 mb-16">
      <router-link to="/"><img src="@/assets/images/v2/Icon awesome-arrow-left.png" alt="" class=""></router-link>
      <router-link class="logout font-bold" to="/logout">Tancar sessió <img src="@/assets/images/v2/Icon ionic-md-exit.png" class="inline ml-2" alt=""></router-link>
    </div>

    <div class="hidden md:block">
      <div class="container">
        <div class="row">
          <div class="col-md-4 offset-md-4 text-center">
            <img src="@/assets/images/v2/Grupo 23.png" style="width: 180px" alt="" class="mx-auto my-8">
          </div>
          <div class="col-md-4 text-right p-8">
              <router-link class="logout font-bold" to="/logout">Tancar sessió <img src="@/assets/images/v2/Icon ionic-md-exit.png" class="inline ml-2" alt=""></router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div v-if="errors.length" style="background-color: #cd1733; color: #fff; text-transform: uppercase; border-radius: 10px; padding: 8px; text-align: center; font-weight: bold; margin-top: 15px;">
        <ul style="margin: 0; padding: 0; list-style: none;">
          <li v-for="error in errors"><i class="fas fa-exclamation-circle"></i> {{ error }}</li>
        </ul>
      </div>
    </div>
    <div class="container" v-if="canResponse && !completed">
      <div class="col-md-12 text-center md:my-24">


        <h1 class="text-5xl text-girona uppercase font-bold">
          Vota l'escut
        </h1>
        <h4 class="font-bold mt-2 mb-6">
            Selecciona la teva opció preferida
        </h4>

        <div class="row">

          <div class="col-md-4 offset-md-2">
            <div class="md:my-8 my-3 cursor-pointer" @click="selectedOption = 1">
              <div class="border-1 border-gray-400 text-girona rounded-2xl p-6" :class="{'border-girona bg-girona text-white': selectedOption == 1}">

                <div class="row items-center">
                  <div class="col-5">
                    <img src="@/assets/images/v2/OpcioA_600x600.gif" alt="" class="rounded-circle mx-auto">
                  </div>
                  <div class="col-7">
                    <p class="text-4xl uppercase font-bold">
                      Opció A
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="md:my-8 my-3 cursor-pointer" @click="selectedOption = 2">
              <div class="border-1 border-gray-400 text-girona rounded-2xl p-6" :class="{'border-girona bg-girona text-white': selectedOption == 2}">

                <div class="row items-center">
                  <div class="col-5">
                    <img src="@/assets/images/v2/OpcioB_600x600.gif" alt="" class="rounded-circle mx-auto">
                  </div>
                  <div class="col-7">
                    <p class="text-4xl uppercase font-bold">
                      Opció B
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-4 offset-md-4 text-center">

            <div class="my-12">
              <div class="font-bold">
                <input type="checkbox" class="mr-4" id="condicions" v-model="condicions" value="condicions">
                <label for="condicions">He llegit i accepto els <router-link class="text-blue-400" to="/termes-condicions" target="_blank">termes i condicions</router-link></label>
              </div>
              <div class="font-bold">
                <input type="checkbox" class="mr-4" id="politica" v-model="politica" value="politica">
                <label for="politica">He llegit i accepto la <a class="text-blue-400" href="https://www.gironafc.cat/politica-de-privacitat" target="_blank">política de privacitat</a></label>
              </div>
            </div>


            <div v-if="isDisabledVote()">
                  <button type="button" disabled class="btn btn-danger btn-block bg-girona uppercase font-normal text-xl rounded-none my-2">
                      Enviar
                  </button>
                  <span class="mb-2 text-girona font-semibold">
                      LA VOTACIÓ HA FINALITZAT
                  </span>
              </div>
            <button v-else @click="submitForm" :disabled="!selectedOption || !condicions || !politica" class="btn btn-danger bg-girona text-white uppercase text-lg px-24 md:mb-32">
              Enviar
            </button>

          </div>
        </div>

      </div>
    </div>

    <div class="container text-center my-12" v-if="completed">
        <h3 class="text-3xl font-bold">
          Has votat l'opció {{ selectedOption == 1 ? 'A' : 'B' }}
        </h3>
        
        <img v-if="selectedOption == 1" src="@/assets/images/v2/OpcioA_600x600.gif" alt="" class="rounded-circle mx-auto my-12 w-1/6">
        <img v-if="selectedOption != 1" src="@/assets/images/v2/OpcioB_600x600.gif" alt="" class="rounded-circle mx-auto my-12 w-1/6">

        <h3 class="text-4xl font-bold text-girona">
          Gràcies per la teva votació!
        </h3>

        <div class="social">
          <p class="mt-12 font-bold">
            Comparteix la teva votació
          </p>
          <div class="icons text-center flex justify-content-center mt-2 mb-24 items-center">
            <a href="whatsapp://send?text=Ja he participat en la votació del nou escut del Girona FC. Socis, participeu-hi!  https://escut.gironafc.cat/" data-action="share/whatsapp/share" target="_blank"><img src="@/assets/images/v2/Icon awesome-whatsapp-square.png" alt="" class="mx-2"></a>
            <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fescut.gironafc.cat%2F" target="_blank"><img src="@/assets/images/v2/Icon awesome-facebook-square.png" alt="" class="mx-2"></a>
            <a href="https://twitter.com/share?text=Ja+he+participat+en+la+votaci%C3%B3+del+nou+escut+del+Girona+FC.+Socis%2C+participeu-hi%21%0D%0A%0D%0Ahttps%3A%2F%2Fescut.gironafc.cat%2F&url=https%3A%2F%2Fescut.gironafc.cat%2F" target="_blank"><img src="@/assets/images/v2/Icon awesome-twitter-square.png" alt="" class="mx-2"></a>
            <!-- <a href="" target="_blank"><img src="@/assets/images/v2/Icon awesome-instagram.png" alt="" class="mx-2"></a> -->
            <a :data-tippy-content="textCopy" class="js-clipboard js-tooltip cursor-pointer" data-clipboard-text="https://escut.gironafc.cat/">
              <img src="@/assets/images/v2/Icon material-insert-link.png" alt="" class="mx-2">
            </a>
          </div>
        </div>
    </div>

     <div class="partners bg-girona mt-12">
        <div class="container">
            <div class="row">
                <div class="col-md-12 my-3 d-flex justify-content-center align-items-center">
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://gosbi.com/" target="_blank">
                            <img src="@/assets/img/partners/gosbi_white.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://eu.puma.com/es/es/home" target="_blank">
                            <img src="@/assets/img/partners/Logo_Puma.png" class="img-fluid" style="width: 100px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://es.costabrava.org/" target="_blank">
                            <img src="@/assets/img/partners/Logo_CostaBrava.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <!-- <div class="mt-3 text-center">
                        <a href="https://www.factorenergia.com/es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Factorenergia.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div> -->
                </div>
                <div class="col-md-12 d-flex justify-content-center align-items-center">
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.estrelladamm.com/es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_EstrellaDamm.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.caixabank.es/particular/home/particulares_es.html" target="_blank">
                            <img src="@/assets/img/partners/Logo_Caixabank.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 text-center">
                        <a href="https://www.nissan.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Nissan.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 ml-5 text-center">
                        <a href="https://www.medplaya.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_MedPlaya.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                </div>
                <div class="col-md-12 my-3 d-flex justify-content-center align-items-center">
                    <!-- <div class="mt-3 mr-5 text-center">
                        <a href="https://leoboeck.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_LeoBoek.png" class="img-fluid" style="width: 170px;" alt="">
                        </a>
                    </div> -->
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.viajeselcorteingles.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_ECI.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <!-- <div class="mt-3 mr-5 text-center">
                        <a href="https://www.besoccer.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_BeSoccer.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div> -->
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://leoboeck.com" target="_blank">
                            <img src="@/assets/img/partners/LeoBoeck_Logo.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>

                    <div class="mt-3 mr-5 text-center">
                        <a href="https://parlem.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Parlem.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

import FormComponent from './FormComponent.vue'
import ClipboardJS from 'clipboard'

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

import moment from 'moment';

export default {
  components: {
    FormComponent,
  },
  data() {
    return {
      errors: [],
      selectedOption: null,
      condicions: false,
      politica: false,
      completed: false,
      canResponse: false,
      textCopy: 'Copiar enllaç',
      now: moment(),
      targetDate: moment("23:59:59 19/09/2021", "HH:mm:ss DD/MM/YYYY"),
    }
  },
  methods: {
    submitForm: function(e) {

      // this.errors = [];
      // let instance = this

      // if (this.condicions === false || this.politica === false ) {
      //   this.errors.push('Per enviar la consulta has de acceptar els termes i condicions i la política de privacitat.');
      //   return false;
      // }

      // let loader = this.$loading.show();

      // let jsonDataApi = {
      //   'id_promocion': 31,
      //   'id_socio': this.$cookies.get('member_number'),
      //   'acepta_condiciones': 1,
      //   'acepta_politica_privacidad': 1,
      //   'recurso_1': this.selectedOption == 1 ? 'A' : 'B',
      // }
      
      // this.$http.post("https://app.gironafcapp.com/apiclient/scripts/api/api.php?format=json&key=54d8e18ba6e4265135cb439484c7f2f8&req=escut_setResponseV2&idSocio=" + this.$cookies.get('member_number') + "&idPromocion=31", jsonDataApi).then((response) => {
      //   if(response.data.result == 'error') {
      //     instance.errors.push(response.data.message)
      //   } else if(response.data.result == 'success' ||this.$cookies.get('member_number') == 49424) {
      //     this.completed = true;
      //     setTimeout(() => {
      //       tippy('.js-tooltip')
      //     }, 1500);
      //   }

      //   loader.hide()

      // })
       this.completed = true;
      e.preventDefault();
    },
    isDisabledVote() {
        return false
        return this.now.isSameOrAfter(this.targetDate)
    }
  },
  mounted() {
    // let member_number = this.$cookies.get("member_number");
    // let instance = this

    // if(!member_number) {
    //   window.location.href = '/login'
    //   return false
    // }

    // var clipboard = new ClipboardJS('.js-clipboard');
    // clipboard.on('success', function(e) {
      
    // });

    // if(member_number == 49424) {
    //   instance.canResponse = true
    //   return false
    // }

    // this.$http.get("https://app.gironafcapp.com/apiclient/scripts/api/api.php?format=json&key=54d8e18ba6e4265135cb439484c7f2f8&req=escut_canResponseV2&idSocio=" + member_number + "&idPromocion=31").then((response) => {
    //   instance.canResponse = response.data.canResponse

    //   if(!instance.canResponse) {
    //     this.errors.push(response.data.message)
    //   }

    //   instance.errorMessage = response.data.message
    // })

    this.canResponse = true
  }
}
</script>
